


















import { defineComponent } from '@vue/composition-api';
import type { PropType } from 'vue';
import { TooltipPlacement } from '../../enums/tooltip-placement';

export default defineComponent({
  props: {
    readEvents: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup() {
    return { TooltipPlacement };
  },
});
